import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ProductCategoryForm from '@app/components/apps/ProductCategories/ProductCategoryForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const EditCategoryPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Product Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/product-categories',
      breadcrumbName: 'Product Categories',
    },
    {
      path: '/edit-product-category',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductCategoryForm
            type="edit"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'Edit Product Category'}
            editable={true}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditCategoryPage;
